/** This file is used for managing environment variables in the project.
 * Add the env here also with validation 
 * Make sure all these requred variables are present in the .env file
 * Dont use process.env directly from the project use this ENV constant instead
 */
import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

// Don't add NODE_ENV into T3 Env, it changes the tree-shaking behavior
export const Env = createEnv({
  client: {
    NEXT_PUBLIC_BACKEND_URL: z.string(),
    NEXT_PUBLIC_FRONTEND_URL: z.string().optional(),
    NEXT_PUBLIC_STATIC_BUCKET_URL: z.string(),
    NEXT_PUBLIC_RAZORPAY_PUBLIC_KEY:z.string()
  },
  server: {
    SKIP_THROTTLER_TOKEN: z.string().optional(),
    SESSION_SECRET: z.string(),
    IOS_APP_STORE_URL:z.string().optional(),
    ANDROID_PLAY_STORE_URL:z.string().optional()
  },
  // You need to destructure all the keys manually
  runtimeEnv: {
    SESSION_SECRET: process.env.SESSION_SECRET,
    NEXT_PUBLIC_BACKEND_URL: process.env.NEXT_PUBLIC_BACKEND_URL,
    NEXT_PUBLIC_FRONTEND_URL: process.env.NEXT_PUBLIC_FRONTEND_URL,
    SKIP_THROTTLER_TOKEN: process.env.SKIP_THROTTLER_TOKEN,
    NEXT_PUBLIC_STATIC_BUCKET_URL: process.env.NEXT_PUBLIC_STATIC_BUCKET_URL,
    NEXT_PUBLIC_RAZORPAY_PUBLIC_KEY:process.env.NEXT_PUBLIC_RAZORPAY_PUBLIC_KEY,
    ANDROID_PLAY_STORE_URL:process.env.ANDROID_PLAY_STORE_URL,
    IOS_APP_STORE_URL:process.env.IOS_APP_STORE_URL
  },
});
